const messages = {
  step3: {
    actionBtn: "Zaloguj się",
  },
};

export default {
  messages,
};
